/**
 * requestAnimationFrame tabanlı throttle fonksiyonu
 * Mouse move gibi yoğun event'ler için optimize edilmiştir
 */
export function throttleRAF(callback) {
  let requestId = null;
  let lastArgs = null;

  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(() => {
        callback(...lastArgs);
        requestId = null;
      });
    }
  };

  throttled.cancel = () => {
    if (requestId !== null) {
      cancelAnimationFrame(requestId);
      requestId = null;
    }
  };

  return throttled;
}

/**
 * Zaman tabanlı throttle fonksiyonu
 * @param {Function} callback - Throttle edilecek fonksiyon
 * @param {number} delay - Minimum gecikme (ms), varsayılan 16ms (~60fps)
 */
export function throttle(callback, delay = 16) {
  let lastCall = 0;
  let timeoutId = null;

  const throttled = (...args) => {
    const now = Date.now();
    const timeSinceLastCall = now - lastCall;

    if (timeSinceLastCall >= delay) {
      lastCall = now;
      callback(...args);
    } else if (!timeoutId) {
      timeoutId = setTimeout(() => {
        lastCall = Date.now();
        callback(...args);
        timeoutId = null;
      }, delay - timeSinceLastCall);
    }
  };

  throttled.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return throttled;
}
